module.exports = __webpack_public_path__ + "static/media/list (1).4ae7894f.svg";